import { createSlice } from '@reduxjs/toolkit';

const initialState = { agecheckid: null, ageverifiedid: null, userinfo: {}, productinfo: {}, productInfoData: {} };

export const response = createSlice({
  name: 'response',
  initialState,
  reducers: {
    _updateAgeCred: (state, action) => {
      console.log('IDS', action);
      //   return action?.payload;
      return { ...state, ...action.payload };
    },
    _flush: () => {
      return initialState;
    },
    updateUserInfo: (state, action) => {
      return { ...state, userinfo: action.payload };
    },
    updateProductInfo: (state, action) => {
      return { ...state, productinfo: action.payload };
    },
    updateProductInfoData: (state, action) => {
      return { ...state, productInfoData: action.payload };
    },

    setClearAgeVerifySession: (state) => {
      state.agecheckid = null;
      state.ageverifiedid = null;
    }
  },
});

export const { _updateAgeCred, _flush, updateUserInfo, updateProductInfo, updateProductInfoData, setClearAgeVerifySession } = response.actions;

export default response.reducer;
